
import React from "react";
import MainLayout from "@/components/layout/MainLayout";
import HeroSection from "@/components/home/HeroSection";
import FeatureSection from "@/components/home/FeatureSection";
import ShareSection from "@/components/home/ShareSection";
import LatestGuides from "@/components/home/LatestGuides";
import { useShareTracking } from "@/hooks/useShareTracking";

const Index = () => {
  useShareTracking();
  
  return (
    <MainLayout>
      <HeroSection />
      <FeatureSection />
      <ShareSection />
      <LatestGuides />
    </MainLayout>
  );
};

export default Index;
